const buildKnotty = require('@homeaway/knotty');

let knotty;

if (typeof window !== 'undefined' && window.__csrfCrumb__) {
  knotty = buildKnotty({
    errorRoute: '/node/home/knotty/errors',
    clientLogRoute: '/node/home/knotty/logs',
    token: window.__csrfCrumb__
  });
  window.onerror = knotty.logException;
}

module.exports = knotty;



// WEBPACK FOOTER //
// ./tools/knotty/index.js